module.exports = __webpack_public_path__ + "img/usuario.158e8bd1.png";